var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "inline-content-container",
      class: [
        _vm.brandKey + "-xp-container",
        {
          all_sport_section: this.section === "all_sports",
          "no-top-margin": this.headlines
        }
      ]
    },
    [
      _vm._l(_vm.filteredData, function(data) {
        return [
          data.onsite_data.type && parseInt(data.onsite_data.type) === 1
            ? _c(
                "section",
                {
                  staticClass:
                    "inline-content-section inline-content-text-only",
                  class: [
                    data.onsite_data.background_color
                      ? _vm.brandKey +
                        "_" +
                        data.onsite_data.background_color.toLowerCase()
                      : ""
                  ],
                  attrs: {
                    "data-cid": data.cid,
                    "data-id": data.id,
                    "data-banner-type": data.onsite_data.type,
                    "data-priority": data.onsite_data.priority
                  }
                },
                [
                  data.onsite_data.dismiss_on_click
                    ? _c(
                        "div",
                        { staticClass: "dismiss" },
                        [
                          _c(
                            "v-btn",
                            { staticClass: "close", attrs: { flat: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onDismiss(data)
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "inline-content",
                      style: _vm.backgroundXPLogo,
                      on: {
                        click: function($event) {
                          return _vm.onContentClick(data)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "content-text" }, [
                        data.onsite_data.lead_text &&
                        typeof data.onsite_data.lead_text === "string"
                          ? _c("span", { staticClass: "text-only" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.lead_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        data.onsite_data.secondary_text &&
                        typeof data.onsite_data.lead_text === "string"
                          ? _c("span", { staticClass: "secondary-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.secondary_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          data.onsite_data.type && parseInt(data.onsite_data.type) === 2
            ? _c(
                "section",
                {
                  staticClass:
                    "inline-content-section inline-content-text-image",
                  class: [
                    data.onsite_data.background_color
                      ? _vm.brandKey +
                        "_" +
                        data.onsite_data.background_color.toLowerCase()
                      : ""
                  ],
                  attrs: {
                    "data-cid": data.cid,
                    "data-id": data.id,
                    "data-banner-type": data.onsite_data.type,
                    "data-priority": data.onsite_data.priority
                  }
                },
                [
                  data.onsite_data.dismiss_on_click
                    ? _c(
                        "div",
                        { staticClass: "dismiss" },
                        [
                          _c(
                            "v-btn",
                            { staticClass: "close", attrs: { flat: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onDismiss(data)
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "inline-content",
                      style: _vm.backgroundXPLogo,
                      on: {
                        click: function($event) {
                          return _vm.onContentClick(data)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "content-text" }, [
                        data.onsite_data.lead_text &&
                        typeof data.onsite_data.lead_text === "string"
                          ? _c("span", { staticClass: "text-image-only" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.lead_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        data.onsite_data.secondary_text &&
                        typeof data.onsite_data.secondary_text === "string"
                          ? _c("span", { staticClass: "secondary-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.secondary_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          data.onsite_data.type && parseInt(data.onsite_data.type) === 3
            ? _c(
                "section",
                {
                  staticClass:
                    "inline-content-section inline-content-text-image-button",
                  class: [
                    data.onsite_data.background_color
                      ? _vm.brandKey +
                        "_" +
                        data.onsite_data.background_color.toLowerCase()
                      : ""
                  ],
                  attrs: {
                    "data-cid": data.cid,
                    "data-id": data.id,
                    "data-banner-type": data.onsite_data.type,
                    "data-priority": data.onsite_data.priority
                  },
                  on: {
                    click: function($event) {
                      return _vm.onContentClick(data, "section")
                    }
                  }
                },
                [
                  data.onsite_data.dismiss_on_click
                    ? _c(
                        "div",
                        { staticClass: "dismiss" },
                        [
                          _c(
                            "v-btn",
                            { staticClass: "close", attrs: { flat: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.onDismiss(data)
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "inline-content",
                      style: _vm.backgroundXPLogo
                    },
                    [
                      _c("div", { staticClass: "content-text" }, [
                        data.onsite_data.lead_text &&
                        typeof data.onsite_data.lead_text === "string"
                          ? _c("span", { staticClass: "lead-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.lead_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        data.onsite_data.secondary_text &&
                        typeof data.onsite_data.secondary_text === "string"
                          ? _c("span", { staticClass: "secondary-text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.onsite_data.secondary_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      data.onsite_data.button
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "content-button",
                              class: [
                                {
                                  "set-small-margin":
                                    data.onsite_data.dismiss === "never" &&
                                    _vm.mobileBigAndBelow
                                }
                              ],
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onContentClick(data, "button")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.onsite_data.button.button_text) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          data.onsite_data.type && parseInt(data.onsite_data.type) === 4
            ? _c(
                "section",
                {
                  staticClass:
                    "inline-content-section inline-content-image-only",
                  class: [
                    data.onsite_data.background_color
                      ? _vm.brandKey +
                        "_" +
                        data.onsite_data.background_color.toLowerCase()
                      : ""
                  ],
                  attrs: {
                    "data-cid": data.cid,
                    "data-id": data.id,
                    "data-banner-type": data.onsite_data.type,
                    "data-priority": data.onsite_data.priority
                  }
                },
                [
                  data.onsite_data.dismiss_on_click
                    ? _c(
                        "div",
                        { staticClass: "dismiss" },
                        [
                          _c(
                            "v-btn",
                            { staticClass: "close", attrs: { flat: "" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onDismiss(data)
                                    }
                                  }
                                },
                                [_vm._v("close")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "inline-content",
                      style: _vm.backgroundXPLogo,
                      on: {
                        click: function($event) {
                          return _vm.onContentClick(data)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "content-text" }, [
                        data.onsite_data.lead_text &&
                        typeof data.onsite_data.lead_text === "string"
                          ? _c("span", { staticClass: "image-only" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(data.onsite_data.lead_text) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9ce7466", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9ce7466","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/XtremepusInlineContent.vue
// module id = null
// module chunks = 